var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('opageHead'),_c('websiteIntroduction'),_c('websiteAdvantages'),_c('popularStores'),_c('howToOperate'),_c('areYouReady'),_c('commonProblem'),_c('registerFoot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }